import angular from 'angular'

angular.module("core.application.main").directive("core.application.main.directive.match", function() {

    var expose = {};
    expose.require = "ngModel";
    expose.restrict = "A";

    expose.link = function($scope, element, attributes, controller) {

        $scope.isMatch = function() {
            var myValue = controller.$viewValue;
            var otherValue = $scope.$eval(attributes.match);
            return myValue === otherValue;
        };

        $scope.$watch(attributes.match, function() {
            controller.$setValidity("match", $scope.isMatch());
        });

        controller.$parsers.unshift(function(viewValue) {
            controller.$setValidity("match", $scope.isMatch());
            return viewValue;
        });

    };

    return expose;
});
